import React from "react"
import logo from "../../public/assets/images/ontario_logo.svg"
import { ProgramContainer, CustomHeaderMenuItem } from "src/entities/formTemplateDataType";
import '../../public/assets/css/App.css';
import SocialMediaComponent from "./SocialMediaComponent";
import UserComponent from "../security/UserComponent";
import { UserProfile } from "../entities/CxpType";
import CustomPopup from "../runtimeComponent/subComponent/PopupComponent";
import { ReactComponent as AccountIcon } from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-account.svg";
import { headerMenu, MenuOptions, menuOptions, withSignOutLast } from "../entities/Constants";
import { cleanup } from "../security/PublicSecure";
import { logout as bpsLogout, getBpsIdToken, getBpsConfig, clearSessionStorage } from "../security/BpsSecure";
import TrackPageView from "../utilities/TrackPageView";
//import {ReactComponent as CloseIcon} from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-close.svg"
import { ReactComponent as ExitIcon } from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-exit.svg";
import { getEnvVar } from "../config/RuntimeConfig";

interface Props {
  programContainer: ProgramContainer;
  isEng: boolean;
  callback;
  callbackStepIndex?: (index: number) => void;
}

interface State {
  isEng: boolean;
  isActive: boolean;
  menuOptions?: MenuOptions[]
}

export class ApplicationHeaderComponent extends React.Component<Props, State> {
  HtmlToReactParser = require('html-to-react').Parser;

  constructor(props: Props) {
    super(props);
    const profileString = sessionStorage.getItem('userProfile');
    const profile: UserProfile | null = profileString ? JSON.parse(profileString) : null;
  
    if(profile && !this.props.programContainer.Profile)
      this.props.programContainer.Profile = profile;

    this.state = {
      isEng: this.props.isEng,
      isActive: false,
      menuOptions: this.getMenuOptions(),
    }

  }

  getMenuOptions = (): MenuOptions[] => {
    const categoryId = this.props.programContainer.CategoryId?.toLowerCase();
    let predefined: MenuOptions[] = headerMenu[categoryId] || [];
    if (this.props.programContainer.ForceApplicationHeaderMenu && this.props.programContainer.HeaderMenuConfig) {
      const configuredIds = this.props.programContainer.HeaderMenuConfig
        .split(',')
        .map(id => id.trim())
        .filter(id => id.length > 0);
      if (configuredIds.length > 0) {
        predefined = menuOptions.filter(option => configuredIds.includes(option.id));
      }
    }
    const customItems = this.props.programContainer.CustomHeaderMenuItems || [];
    const customOptions: MenuOptions[] = customItems.map((item: CustomHeaderMenuItem, idx: number) => ({
      id: `custom-${idx}`,
      'title-en': item.TitleEN || '',
      'title-fr': item.TitleFRA || '',
      'link-en': item.LinkEN || '',
      'link-fr': item.LinkFRA || '',
      icon: '#ontario-icon-document',
    }));
    let allOptions = [...predefined, ...customOptions];
    if (!this.props.programContainer.AuthRequired) {
      allOptions = allOptions.filter(o => o.id !== 'signout');
    }
    return withSignOutLast(allOptions);
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.programContainer !== this.props.programContainer ||
        prevProps.programContainer?.CustomHeaderMenuItems !== this.props.programContainer?.CustomHeaderMenuItems ||
        prevProps.programContainer?.HeaderMenuConfig !== this.props.programContainer?.HeaderMenuConfig) {
      this.setState({ menuOptions: this.getMenuOptions() });
    }
  }

  handleMenuItem = (e) => {
    const target = e.target as HTMLElement;
    const listItem = target.closest?.('li');
    const anchor = listItem?.querySelector?.('a');
    const id = anchor?.id ?? target.id;
    const menuItem = id ? this.state.menuOptions.find(option => option.id === id) : null;
    if (!menuItem) {
      this.setState({ isActive: false });
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    this.setState({ isActive: false });

    if (String(menuItem.id).startsWith('custom-')) {
      const idx = parseInt(String(menuItem.id).replace('custom-', ''), 10);
      const customItems = this.props.programContainer.CustomHeaderMenuItems || [];
      const customItem = customItems[idx];
      if (customItem?.StepperScript?.trim() && this.props.callbackStepIndex) {
        try {
          const customJSFunc = eval(`(${customItem.StepperScript})`);
          customJSFunc((index: number) => this.props.callbackStepIndex(index));
        } catch (err) {
          console.error('Custom header menu stepper script error:', err);
        }
      }
      const url = this.getMenuLinkUrl(menuItem);
      if (url) {
        window.location.assign(url);
      }
      return;
    }

    const app = this.props.programContainer.CategoryId?.toLowerCase() === 'otrip' ? 'otris' : this.props.programContainer.CategoryId?.toLowerCase();

    if (menuItem.id === 'signout') {
      const authRequired = this.props.programContainer.AuthRequired?.toLowerCase();
      const isBpsFlow =
        authRequired === 'bps' ||
        !!this.props.programContainer.BpsConfig?.logoutEndpoint;

      if (isBpsFlow) {
        const bpsConfig = getBpsConfig(this.props.programContainer);
        const idToken = getBpsIdToken();
        const postLogoutRedirectUri = bpsConfig.logoutEndpoint;

        if (idToken && bpsConfig?.domain) {
          const bpsBaseUrl = getEnvVar('BPS_BASE_URL') || 'https://stage.login.security.gov.on.ca';
          const logoutUrl = `${bpsBaseUrl}/oauth2/rest/userlogout?id_token_hint=${encodeURIComponent(idToken)}&post_logout_redirect_uri=${encodeURIComponent(postLogoutRedirectUri)}&domain=${encodeURIComponent(bpsConfig.domain)}`;
          clearSessionStorage();
          window.location.href = logoutUrl;
          return;
        }
        
        // Fallback to standard bpsLogout if id_token or domain is missing
        bpsLogout(this.props.programContainer, postLogoutRedirectUri);
        return;
      }
    }

    cleanup(app, this.props.programContainer);
    const url = this.getMenuLinkUrl(menuItem);
    window.location.assign(url);
  }

  getMenuLinkUrl = (option: MenuOptions) => {
    if (String(option.id).startsWith('custom-')) {
      const lang = this.props.isEng ? 'en' : 'fr';
      return option[`link-${lang}`] || option['link-en'] || option['link-fr'] || '';
    }
    const app = this.props.programContainer.CategoryId?.toLowerCase();
    const lang = this.props.isEng ? 'en' : 'fr';
    let url = option[`link-${lang}`];

    if (option.id === 'signout') {
      url = url + `/${app}`;
    }
    return url;
  }
  
  addFrToUrl = () => {
    const enUrlString = window.location.href
    sessionStorage.setItem('previousUrl', enUrlString);
    let frUrlString
    if (enUrlString.includes("/on-form/")) {
      frUrlString = enUrlString.replace("/on-form/", "/on-form/fr/");
    } else {
      frUrlString = enUrlString + "/fr";
    }

    window.history.pushState({}, '', frUrlString);
    sessionStorage.setItem("languageChange", "true");
    TrackPageView(this.props.programContainer)
  }

  removeFrToUrl = () => {
    const url = window.location.href;
    sessionStorage.setItem('previousUrl', url);
    sessionStorage.setItem("languageChange", "true");
    if (url.includes("/fr")) {
      const newUrl = url.replace("/fr", "");
      window.history.pushState(null, "", newUrl);
    }

    TrackPageView(this.props.programContainer);
  }

  generateHeaderString = () => {
    const htmlToReactParser = new this.HtmlToReactParser();
    let parsedCustomHeader = null;
    // Check if the custom header is provided in English or French
    if (this.props.isEng && this.props.programContainer.CustomApplicationHeader) {
      parsedCustomHeader = htmlToReactParser.parse(this.props.programContainer.CustomApplicationHeader);
    } else if (!this.props.isEng && this.props.programContainer.CustomApplicationHeaderFRA) {
      parsedCustomHeader = htmlToReactParser.parse(this.props.programContainer.CustomApplicationHeaderFRA);
    }

    return (

      <div className='documentation-only--application'>
        <div className='ontario-header__container'>
          <header className='ontario-application-header ontario-header' id='ontario-header'>
            <div className='ontario-row'>
              <div className='ontario-columns ontario-small-6 ontario-application-header__logo'>
                <a href='https://www.ontario.ca/page/government-ontario'>
                  <img id="asap-logo" src={logo} alt="Government of Ontario" />
                </a>
              </div>
              <div className='ontario-columns ontario-small-6 ontario-application-header__lang-toggle'
                style={this.props.programContainer.EnglishOnly ? { visibility: 'hidden' } : undefined}>
                <button lang={this.state.isEng ? 'fr' : 'en'} className='ontario-header__language-toggler ontario-header-button ontario-header-button--without-outline'
                  onClick={() => this.setState({ isEng: !this.state.isEng }, () => this.props.callback(!this.props.isEng))}>
                  {this.state.isEng ? 'Français' : 'English'}
                </button>
              </div>
            </div>
          </header>
          <div className='ontario-application-subheader-menu__container'>
            {this.props.programContainer.HideApplicationName === true ?
              ((this.state.isEng
                ? this.props.programContainer.CustomApplicationHeader
                : this.props.programContainer.CustomApplicationHeaderFRA) && (
                  <div className="ontario-application-subheader">
                    {parsedCustomHeader}
                  </div>
                )) :
              <section className='ontario-application-subheader'>
                <div className='ontario-row'>
                  <div className='ontario-columns ontario-small-12 ontario-application-subheader__container'>
                    {/* Custom header content if present */}

                    <p className='ontario-application-subheader__heading' style={{ whiteSpace: 'pre-wrap' }}>
                      <a className="not-clickable" href="#">{this.props.isEng ? this.props.programContainer.Name : this.props.programContainer.NameFRA}</a>
                    </p>
                    <div style={{ display: this.props.programContainer.SocialMedia == "Y" ? "block" : "none" }} >
                      <SocialMediaComponent isEng={this.props.isEng} GATrackingID={this.props.programContainer.GATrackingID}></SocialMediaComponent>
                    </div>
                    {this.props.programContainer.AuthRequired == "ad" && (
                      <div className='ontario-application-subheader__heading'>
                        <a className="not-clickable"><UserComponent isEng={this.props.isEng} categoryId={this.props.programContainer.CategoryId} scopes={this.props.programContainer.Scopes} callback={() => this.props.callback()} /></a>
                      </div>
                    )}
                    {((this.props.programContainer.Profile && this.props.programContainer.Profile?.userId) || this.props.programContainer.ForceApplicationHeaderMenu || (this.props.programContainer.CustomHeaderMenuItems?.length > 0)) && this.state.menuOptions?.length && (
                      <div className="header-submenu">
                        <div role="navigation" aria-label="Main">
                          <button
                            className="header__menu-toggler header-button header-button--with-outline submenu_button ontario-header__menu-toggler ontario-header-button ontario-header-button--with-outline"
                            id="ontario-header-menu-toggler"
                            aria-controls="ontario-navigation"
                            aria-expanded={this.state.isActive}
                            aria-label={this.state.isActive ? 'Hide navigation menu' : 'Show navigation menu'}
                            type="button"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              this.setState((prev) => ({ isActive: !prev.isActive }));
                            }}
                          >
                              <svg className="ontario-icon" focusable="false" aria-hidden="true" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                              <use xlinkHref={
                                    this.state.isActive
                                      ? '#ontario-icon-close' 
                                      : '#ontario-icon-menu'  
                                  }                       
                                  id="ontario-header-menu-icon" />
                            </svg>
                            <span>Menu</span>
                          </button>
                          {this.state.isActive && (
                            <CustomPopup
                              id="header-menu-popup"
                              onClickOutside={() => {
                                this.setState({ isActive: false });
                              }}
                              isVisible={this.state.isActive}
                              handleCustomEvent={this.handleMenuItem}
                            >
                              <ul className="submenu-items">
                                {this.state.menuOptions?.map(option => (
                                  <li key={option.id}>
                                    {option.id === 'signout' &&  <ExitIcon
                                        width={24}
                                        height={24}
                                        role="img"
                                        aria-hidden="true"
                                        aria-label={this.props.isEng ? option["title-en"] : option["title-fr"]}
                                      />
                                    }
                                    {option.id === 'myAccount' && <AccountIcon
                                      width={24} height={24}
                                      alt={this.props.isEng ? 'account' : 'Compte'}
                                      role='img'
                                      fill="#000"
                                    />}
                                    {String(option.id).startsWith('custom-') && (
                                      <svg className="ontario-icon" width={24} height={24} focusable="false" aria-hidden="true" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" role="img" aria-label={this.props.isEng ? option["title-en"] : option["title-fr"]}>
                                        <use xlinkHref="#ontario-icon-document" />
                                      </svg>
                                    )}
                                    {!['myAccount', 'signout'].includes(option.id) && !String(option.id).startsWith('custom-') && (
                                      option.icon?.startsWith('#') ? (
                                        <svg className="ontario-icon" width={24} height={24} focusable="false" aria-hidden="true" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" role="img" aria-label={this.props.isEng ? option["title-en"] : option["title-fr"]}>
                                          <use xlinkHref={option.icon} />
                                        </svg>
                                      ) : (
                                        <img src={option.icon}
                                          width={24} height={24}
                                          alt=""
                                          role='img'
                                        />
                                      )
                                    )}
                                    <a id={option.id} href={this.getMenuLinkUrl(option)}>
                                      {this.props.isEng ? option["title-en"] : option["title-fr"]}
                                    </a>
                                  </li>
                                ))}
                              </ul>
                            </CustomPopup>
                          )}
                        </div>
                      </div>
                      )}
                  </div>
                  
                </div>
                <div className='ontario-row'>
                  {parsedCustomHeader}
                </div>
              </section>
            }
          </div>
        </div>
        <div className='ontario-overlay'></div>
      </div>)
  }




  render() {
    return (
      <div style={{ marginBottom: '50px' }}>
        {this.generateHeaderString()}
      </div>

    )
  }
}
